import React from 'react';

export default function PurchaseError() {
  return (
    <React.Fragment>
      <p>Error</p>
    </React.Fragment>
  )
}